import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { cosmosCardMotion } from './motion';
import { cosmosChromeTone } from './palette';

export const cosmosTheme: FlowThemeDefinition = {
  id: 'cosmos',
  label: 'Cosmos',
  description: 'A probe slingshots past a new planet with every step, and finishing blooms a spiral galaxy across the sky.',
  category: 'night',
  chromeTone: cosmosChromeTone,
  swatch: 'linear-gradient(160deg, #3B1328 0%, #0C2140 45%, #300B4A 85%, #FF6AD5 100%)',
  cardGlass: 'dense',
  cardMotion: cosmosCardMotion,
  burstSize: 320,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createCosmosScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
